"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Content = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _metrics = require("../../_helpers/metrics");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Card.css");

var _styles = {
  "container": "Card__container___E2bhW",
  "clickable": "Card__clickable___3gdSV",
  "content": "Card__content___2J1VD",
  "flex": "Card__flex___3ZTVH"
};

const styles = _bind.default.bind(_styles);

const Card = (0, _mobxReact.observer)(({
  className,
  children,
  maxWidth,
  noMargin,
  dataTestId,
  onClick,
  noBorder,
  noBoxShadow,
  bgColor,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('container', {
    clickable: !!onClick
  }), className);
  const composed_styles = {
    maxWidth: `${maxWidth}px`,
    width: maxWidth ? '100%' : undefined,
    border: noBorder ? 'none' : undefined,
    boxShadow: noBoxShadow ? 'none' : undefined,
    backgroundColor: bgColor && bgColor,
    margin: noMargin ? 0 : undefined
  };
  return _react.default.createElement("div", {
    className: composed_classname,
    style: composed_styles,
    "data-testid": dataTestId,
    onClick: () => {
      if (dataTestId) {
        (0, _metrics.trackAction)(`click on ${dataTestId}`);
      }

      if (onClick) {
        onClick();
      }
    },
    ...props
  }, children);
});
const Content = (0, _mobxReact.observer)(({
  className,
  children,
  flex,
  flexWrap,
  flexDirection,
  justifyContent,
  gap,
  alignItems,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTopBottom,
  paddingLeftRight,
  bgColor,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('content', {
    flex
  }), className);
  const composed_styles = {
    gap: gap && `${gap}px`,
    flexWrap,
    flexDirection,
    justifyContent,
    alignItems,
    paddingTop: (paddingTop || paddingTopBottom) && `${paddingTop || paddingTopBottom}px`,
    paddingBottom: (paddingBottom || paddingTopBottom) && `${paddingBottom || paddingTopBottom}px`,
    paddingLeft: (paddingLeft || paddingLeftRight) && `${paddingLeft || paddingLeftRight}px`,
    paddingRight: (paddingRight || paddingLeftRight) && `${paddingRight || paddingLeftRight}px`,
    backgroundColor: bgColor && bgColor
  };
  return _react.default.createElement("div", {
    className: composed_classname,
    style: composed_styles,
    "data-testid": dataTestId,
    ...props
  }, children);
});
exports.Content = Content;
var _default = Card;
exports.default = _default;